// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__3GgJ3","loading":"Button_loading___7u6u","button-loading-spinner":"Button_button-loading-spinner__1hU7n","inverted":"Button_inverted__3--Cn"};